import { render, staticRenderFns } from "./ExchangePrize.vue?vue&type=template&id=4509681a&scoped=true&"
import script from "./ExchangePrize.vue?vue&type=script&lang=js&"
export * from "./ExchangePrize.vue?vue&type=script&lang=js&"
import style0 from "./ExchangePrize.vue?vue&type=style&index=0&id=4509681a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4509681a",
  null
  
)

export default component.exports